import { DispatcherEvent } from '@carvana/merch-native';
import { useSubsequentEffect } from '@carvana/merch-react-hooks';
import { useHasAppliedTrade } from '~/contexts/SearchContext';
import sendMessageToNative from './sendMessageToNative';

export default function useTradeInAppliedDispatcher(): void {
  const isTradeInApplied = useHasAppliedTrade();

  useSubsequentEffect(() => {
    sendMessageToNative(DispatcherEvent.ToggleTradeIn, { isTradeInApplied });
  }, [isTradeInApplied]);
}
